import { http, HttpResponse } from 'msw'

import { allSales } from '@/mocks/data/transactions/sales'

import { isNumeric } from '@/utils/app/number'
import { api } from '@/utils/constants'

import type { SalesRequest } from '@/types/transactions/sale'

export const getAllSales = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.transactions.sales.LIST}`,
    ({ request }) => {
        const url = new URL(request.url)
        const limitQuery = url.searchParams.get('limit')
        const offsetQuery = url.searchParams.get('offset')

        // Pagination
        const limit = isNumeric(limitQuery) ? Number(limitQuery) : 10
        const offset = isNumeric(offsetQuery) ? Number(offsetQuery) : 0

        const limitArray =
            allSales.length > limit ? offset + limit : allSales.length

        const results = allSales.slice(offset, limitArray)

        const next =
            offset + results.length < allSales.length ? 'again' : undefined

        return HttpResponse.json<SalesRequest>({
            next,
            results,
        })
    },
)
